import { render, staticRenderFns } from "./SaleReportAllCustomer.vue?vue&type=template&id=485b282b&"
import script from "./SaleReportAllCustomer.vue?vue&type=script&lang=js&"
export * from "./SaleReportAllCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports